import React from 'react'
import HomeSectionTitle from '../HomeSectionTitle'
import HomeSavedSearchesSlider from './HomeSavedSearchesSlider'

export default function HomeSavedSearches() {
    return (
        <div className='w-full mt-11'>
            <div className='pl-[0.625rem] mb-4'>
                <HomeSectionTitle title="SAVED SEARCHES (0)" />
            </div>
            <HomeSavedSearchesSlider />
        </div>
    )
}
